import axiosInstance from './axiosInstance';

export interface Bank {
  bankId: number;
  bankName: string;
  bankNameAr: string;
  bankCode: string;
  swiftCode: string;
  bankShortName: string;
  isActive: boolean;
}

const API_URL = '/Banks';

const banksService = {
  getAll: async (): Promise<Bank[]> => {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  },

  getActive: async (): Promise<Bank[]> => {
    const response = await axiosInstance.get(`${API_URL}/active`);
    return response.data;
  },

  getById: async (id: number): Promise<Bank> => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (bank: Partial<Bank>): Promise<Bank> => {
    const response = await axiosInstance.post(API_URL, bank);
    return response.data;
  },

  update: async (id: number, bank: Partial<Bank>): Promise<Bank> => {
    const response = await axiosInstance.put(`${API_URL}/${id}`, bank);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  }
};

export default banksService;